export const config = {
    backendUrl: process.env.VUE_APP_BACKEND_URL,
    appVersion: "2.4.1"
};
